// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/1.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* reset */
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

/* app componenet */
.header-container {
  text-align: center;
  width: 100%;
  background-color: #293241;
  font-family: Arial, sans-serif;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 90%;
  margin-inline: auto;
  padding: 20px 0;
  font-size: 24px;
  color: #ffffff;
}

.header-buttons {
  display: flex;
  gap: 30px;
}

.header-button {
  display: inline-block;
  padding: 12px 24px;
  background-color: #4a6572;
  color: #ffffff;
  text-align: center;
  text-decoration: none;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  cursor: pointer;
}

.header-button:hover {
  background-color: #5a7d9a;
}

.header-title {
  display: inline-block;
  animation: changeColor 1s infinite linear alternate;
}

@keyframes changeColor {
  0% {
    color: white;
  }
  50% {
    color: #4a6572;
  }
  100% {
    color: white;
  }
}

/* home page */
.home-page {
  margin: 20px auto;
  max-width: 90%;
}
.create-block__error {
  color: red;
}

.home-page__button-block {
  display: flex;
  justify-content: center;
  gap: 20px;
  max-width: 90%;
  margin-inline: auto;
  align-items: center;
  margin-top: 20px;
}

.home-page__action-button {
  display: inline-block;
  background-color: #4a6572;
  color: #ffffff;
  text-align: center;
  text-decoration: none;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  cursor: pointer;
}

.home-page__action-button:hover {
  background-color: #5a7d9a;
}

.home-page__garage-info > span {
  margin-bottom: 10px;
  color: #ff0000;
  font-weight: 700;
  font-size: xx-large;
}

.home-page__winner-info {
  position: absolute;
  right: 0;
  left: 0;
  top: 50%;
  color: #c70d0d;
  font-weight: bold;
  max-width: 50%;
  margin: 0 auto;
  font-size: 30px;
  font-weight: bold;
  padding: 10px;
  background-color: rgba(0, 0, 0, 0.288);
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* colorFOrm component */
.color-form {
  display: flex;
  gap: 20px;
  margin: 0 auto;
  padding: 20px;
  border-radius: 10px;
  justify-content: center;
}

.color-form__input {
  padding: 15px;
  border: 2px solid #ced4da;
  border-radius: 5px;
  font-size: 16px;
  outline: none;
  transition: border-color 0.3s ease;
  max-width: 300px;
}

.color-form__input:focus {
  border-color: #007bff;
}

.color-form__color {
  height: 50px;
  width: 50px;
  border: none;
  border-radius: 5px;
  outline: none;
}

.color-form__error {
  color: #dc3545;
  font-size: 14px;
  padding-top: 20px;
}

.color-form__button {
  height: 50px;
  width: 200px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.color-form__button:hover {
  background-color: #0056b3;
}

.color-form__button:disabled,
.home-page__action-button:disabled {
  background-color: #ced4da;
  cursor: not-allowed;
}

.color-form__button:disabled:hover,
.home-page__action-button:disabled {
  background-color: #ced4da;
  cursor: not-allowed;
}

/* car */
.car {
  width: 100px;
  position: relative;
  min-height: 70px;
}

.car-component {
  margin: 20px auto;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.car-component__image-block {
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: auto 90px;
}

.car-component__image-car {
  color: #dc3545;
  font-size: 20px;
  font-style: italic;
}

/* page */
.page-block {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin: 0 auto;
  margin-top: 20px;
  align-items: center;
  width: 100%;
}

.page-block__garage-text {
  font-size: 20px;
}

.page-block__btn-arrow {
  font-size: 20px;
  cursor: pointer;
  padding: 2px 3px;
}

/* modal css */
.modal {
  position: fixed;
  right: 0;
  left: 0;
  bottom: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal__container {
  width: 500px;
  height: 200px;
  padding: 20px;
  border-radius: 20px;
  text-align: center;
  background-color: #293241;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.modal__message {
  margin-bottom: 10px;
  color: #fff;
  font-size: 18px;
}

.modal__link {
  color: #ea3939;
  text-decoration: none;
  padding-left: 20px;
}

.modal__link:hover {
  text-decoration: underline;
}

/* winners page */

.winners-page {
  margin: 0 auto;
  width: 90%;
}

.winners-page__total {
  font-size: 25px;
  color: #ff0000;
  margin: 50px 0;
}

.winners-page__table {
  display: table;
  width: 100%;
  margin-top: 20px;
}

.winners-page__row {
  display: table-row;
}

.winners-page__header {
  font-weight: bold;
}

.winners-page__cell {
  display: table-cell;
  padding: 8px;
}

.winners-page__cell:hover {
  cursor: pointer;
}

.winners-page__cell img {
  display: block;
  margin: 0 auto;
}

.winners-page__cell:hover {
  cursor: pointer;
}

.car-winners-page {
  top: -25px;
  position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,UAAU;AACV;EACE,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;AACF;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,sCAAsC;EACtC,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,QAAQ;AACR;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yDAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,eAAe;EACf,QAAQ;EACR,OAAO;EACP,SAAS;EACT,MAAM;EACN,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,iBAAiB;;AAEjB;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB","sourcesContent":["/* reset */\n* {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n/* app componenet */\n.header-container {\n  text-align: center;\n  width: 100%;\n  background-color: #293241;\n  font-family: Arial, sans-serif;\n}\n\n.header-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  max-width: 90%;\n  margin-inline: auto;\n  padding: 20px 0;\n  font-size: 24px;\n  color: #ffffff;\n}\n\n.header-buttons {\n  display: flex;\n  gap: 30px;\n}\n\n.header-button {\n  display: inline-block;\n  padding: 12px 24px;\n  background-color: #4a6572;\n  color: #ffffff;\n  text-align: center;\n  text-decoration: none;\n  border-radius: 5px;\n  transition: background-color 0.3s ease;\n  cursor: pointer;\n}\n\n.header-button:hover {\n  background-color: #5a7d9a;\n}\n\n.header-title {\n  display: inline-block;\n  animation: changeColor 1s infinite linear alternate;\n}\n\n@keyframes changeColor {\n  0% {\n    color: white;\n  }\n  50% {\n    color: #4a6572;\n  }\n  100% {\n    color: white;\n  }\n}\n\n/* home page */\n.home-page {\n  margin: 20px auto;\n  max-width: 90%;\n}\n.create-block__error {\n  color: red;\n}\n\n.home-page__button-block {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  max-width: 90%;\n  margin-inline: auto;\n  align-items: center;\n  margin-top: 20px;\n}\n\n.home-page__action-button {\n  display: inline-block;\n  background-color: #4a6572;\n  color: #ffffff;\n  text-align: center;\n  text-decoration: none;\n  border-radius: 5px;\n  transition: background-color 0.3s ease;\n  cursor: pointer;\n}\n\n.home-page__action-button:hover {\n  background-color: #5a7d9a;\n}\n\n.home-page__garage-info > span {\n  margin-bottom: 10px;\n  color: #ff0000;\n  font-weight: 700;\n  font-size: xx-large;\n}\n\n.home-page__winner-info {\n  position: absolute;\n  right: 0;\n  left: 0;\n  top: 50%;\n  color: #c70d0d;\n  font-weight: bold;\n  max-width: 50%;\n  margin: 0 auto;\n  font-size: 30px;\n  font-weight: bold;\n  padding: 10px;\n  background-color: rgba(0, 0, 0, 0.288);\n  height: 200px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* colorFOrm component */\n.color-form {\n  display: flex;\n  gap: 20px;\n  margin: 0 auto;\n  padding: 20px;\n  border-radius: 10px;\n  justify-content: center;\n}\n\n.color-form__input {\n  padding: 15px;\n  border: 2px solid #ced4da;\n  border-radius: 5px;\n  font-size: 16px;\n  outline: none;\n  transition: border-color 0.3s ease;\n  max-width: 300px;\n}\n\n.color-form__input:focus {\n  border-color: #007bff;\n}\n\n.color-form__color {\n  height: 50px;\n  width: 50px;\n  border: none;\n  border-radius: 5px;\n  outline: none;\n}\n\n.color-form__error {\n  color: #dc3545;\n  font-size: 14px;\n  padding-top: 20px;\n}\n\n.color-form__button {\n  height: 50px;\n  width: 200px;\n  background-color: #007bff;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.color-form__button:hover {\n  background-color: #0056b3;\n}\n\n.color-form__button:disabled,\n.home-page__action-button:disabled {\n  background-color: #ced4da;\n  cursor: not-allowed;\n}\n\n.color-form__button:disabled:hover,\n.home-page__action-button:disabled {\n  background-color: #ced4da;\n  cursor: not-allowed;\n}\n\n/* car */\n.car {\n  width: 100px;\n  position: relative;\n  min-height: 70px;\n}\n\n.car-component {\n  margin: 20px auto;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n}\n\n.car-component__image-block {\n  padding: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-image: url(\"./assets/1.png\");\n  background-size: auto 90px;\n}\n\n.car-component__image-car {\n  color: #dc3545;\n  font-size: 20px;\n  font-style: italic;\n}\n\n/* page */\n.page-block {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  margin: 0 auto;\n  margin-top: 20px;\n  align-items: center;\n  width: 100%;\n}\n\n.page-block__garage-text {\n  font-size: 20px;\n}\n\n.page-block__btn-arrow {\n  font-size: 20px;\n  cursor: pointer;\n  padding: 2px 3px;\n}\n\n/* modal css */\n.modal {\n  position: fixed;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  top: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.modal__container {\n  width: 500px;\n  height: 200px;\n  padding: 20px;\n  border-radius: 20px;\n  text-align: center;\n  background-color: #293241;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n}\n\n.modal__message {\n  margin-bottom: 10px;\n  color: #fff;\n  font-size: 18px;\n}\n\n.modal__link {\n  color: #ea3939;\n  text-decoration: none;\n  padding-left: 20px;\n}\n\n.modal__link:hover {\n  text-decoration: underline;\n}\n\n/* winners page */\n\n.winners-page {\n  margin: 0 auto;\n  width: 90%;\n}\n\n.winners-page__total {\n  font-size: 25px;\n  color: #ff0000;\n  margin: 50px 0;\n}\n\n.winners-page__table {\n  display: table;\n  width: 100%;\n  margin-top: 20px;\n}\n\n.winners-page__row {\n  display: table-row;\n}\n\n.winners-page__header {\n  font-weight: bold;\n}\n\n.winners-page__cell {\n  display: table-cell;\n  padding: 8px;\n}\n\n.winners-page__cell:hover {\n  cursor: pointer;\n}\n\n.winners-page__cell img {\n  display: block;\n  margin: 0 auto;\n}\n\n.winners-page__cell:hover {\n  cursor: pointer;\n}\n\n.car-winners-page {\n  top: -25px;\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
